const Contact = () => {

    const destination = "This is a working contact form. Get your free access key from: https://web3forms.com/ ";

    return ( 
        <div class="flex items-center justify-center p-12 bg-gray-100">
        
            <div class="mx-auto w-full max-w-[750px] mt-10 font-fonts">
                <form action="https://api.web3forms.com/submit" method="POST">
                <div class="mb-5">
                    <label
                    for="name"
                    class="mb-3 block text-base font-medium text-slate-400"
                    >
                    <input type="hidden" name="access_key" value="7e5ae4a0-7a76-4b71-9a84-92382aed8aad"/>
                    Full Name
                    </label>
                    <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Full Name"
                    class="w-full rounded-md border border-slate-600 bg-gray-100 py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-2 focus:shadow-md"
                    required
                    />
                </div>
                <div class="mb-5">
                    <label
                    for="email"
                    class="mb-3 block text-base font-medium text-slate-400"
                    >
                    Email Address
                    </label>
                    <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="example@domain.com"
                    required
                    class="w-full rounded-md border border-slate-600 bg-gray-100 py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-2 focus:shadow-md"
                    />
                </div>
                <div class="mb-5">
                    <label
                    for="subject"
                    class="mb-3 block text-base font-medium text-slate-400"
                    >
                    Subject
                    </label>
                    <input
                    type="text"
                    name="subject"
                    id="subject"
                    placeholder="Enter your subject"
                    required
                    class="w-full rounded-md border border-slate-600 bg-gray-100 py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-2 focus:shadow-md"
                    />
                </div>
                <div class="mb-5">
                    <label
                    for="message"
                    class="mb-3 block text-base font-medium text-slate-400"
                    >
                    Message
                    </label>
                    <textarea
                    rows="4"
                    name="message"
                    id="message"
                    placeholder="Type your message"
                    class="w-full resize-none rounded-md border border-slate-600 bg-gray-100 py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-2 focus:shadow-md"
                    ></textarea>
                </div>
                <input type="hidden" name="redirect" value="https://web3forms.com/success"/>
                <div>
                    <button
                    class="hover:opacity-50 rounded-md bg-gray-800 py-3 px-8 text-base font-semibold text-gray-100 outline-none"
                    >
                    Submit
                    </button>
                </div>
                </form>
            </div>
        </div>
     );
}
 
export default Contact;